<app-orders-nav [activeMenuItem]="'queued_for_conversion'"></app-orders-nav>


<mat-card class="content-card">

  <h2>Pending card conversions</h2>

  <button mat-raised-button color="turquoise" [disabled]="pendingConversions == null || pendingConversions.length == 0" (click)="executeConversions()">Execute Pending Conversions</button><br />
  <div style="margin-top: 5px;"><small>This will execute all pending card conversions and order the new plastic cards to be produced</small></div>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px">

  </div>

  <mat-table [dataSource]="pendingConversions">

    <ng-container matColumnDef="token">
      <mat-header-cell *matHeaderCellDef> Token </mat-header-cell>
      <mat-cell *matCellDef="let conversion"> {{conversion.card.token }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="queued">
      <mat-header-cell *matHeaderCellDef> Queued </mat-header-cell>
      <mat-cell *matCellDef="let conversion"> {{ this.datePipe.transform(conversion.queueDate, 'dd.MM.yyyy HH:mm')  }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="customer">
      <mat-header-cell *matHeaderCellDef>Customer</mat-header-cell>
      <mat-cell *matCellDef="let conversion">
        <a [routerLink]="'../customers-overview/' + conversion.card.customerId">{{conversion.card.customer?.firstName}} {{conversion.card.customer?.lastName}}</a>



      </mat-cell>
    </ng-container>


    <ng-container matColumnDef="badges">
      <mat-header-cell *matHeaderCellDef> KYC </mat-header-cell>
      <mat-cell *matCellDef="let conversion">

        <app-customer-badges [compact]="true" [hideSof]="true" [hideRisk]="true" [hideVulnerable]="true" [customer]="conversion.card.customer"></app-customer-badges>

      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cardType">
      <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
      <mat-cell *matCellDef="let conversion">
        <ng-container *ngIf="conversion.fromType === cardType.Pseudo ">Pseudo</ng-container>
        <ng-container *ngIf="conversion.fromType === cardType.Virtual ">Virtual</ng-container>
        <ng-container *ngIf="conversion.fromType === cardType.Physical ">Physical</ng-container>
        <ng-container *ngIf="conversion.fromType === cardType.InitiallyVirtual ">I. Virtual</ng-container>
        ➡️
        <ng-container *ngIf="conversion.toType === cardType.Virtual ">Virtual</ng-container>
        <ng-container *ngIf="conversion.toType === cardType.Physical ">Physical</ng-container>
        <ng-container *ngIf="conversion.toType === cardType.InitiallyVirtual ">I. Virtual</ng-container>
        <ng-container *ngIf="conversion.toType === cardType.Pseudo ">Pseudo</ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="exp">
      <mat-header-cell *matHeaderCellDef> Exp </mat-header-cell>
      <mat-cell *matCellDef="let conversion"> {{conversion.card.expireDate| date: 'MM/yy'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="rm">
      <mat-header-cell *matHeaderCellDef>Remove</mat-header-cell>
      <mat-cell *matCellDef="let conversion">
        <mat-icon (click)="removeCardFromConversions(conversion)" style="color: red; cursor: pointer">cancel</mat-icon>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['token', 'queued', 'customer', 'badges', 'cardType', 'exp', 'rm']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['token', 'queued', 'customer', 'badges', 'cardType', 'exp', 'rm']"></mat-row>

  </mat-table>

</mat-card>
